var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnetreeplantedlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 359.246,
    height: 83.168,
    viewBox: "0 0 359.246 83.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(85.516 143.674)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M17.352-86.176c-5.239,0-8.76-4.379-8.76-15.93s3.521-15.931,8.76-15.931,8.76,4.379,8.76,15.931S22.591-86.176,17.352-86.176Zm0-29.027c-3,0-5.411,2.576-5.411,13.1s2.406,13.1,5.411,13.1,5.411-2.575,5.411-13.1S20.358-115.2,17.352-115.2Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M35.429-117.607l7.986,22.844H43.5v-22.844h3.35v31H43.243l-9.618-26.968h-.086V-86.6h-3.35v-31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M65.889-117.607v2.834H55.067v10.563h7.988v2.834H55.067v11.939H66.4V-86.6H51.718v-31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M73.808-112.97H68.655v-4.637H84.286v4.637H79.133V-86.6H73.808Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M92.695-86.6H87.37v-31h7.473c5.967,0,9.017,2.532,9.017,9.146,0,4.982-1.932,7-3.736,7.816L104.633-86.6h-5.41l-3.78-12.841a25.356,25.356,0,0,1-2.748.13Zm0-17.092h1.889c2.878,0,3.951-1.073,3.951-4.766s-1.073-4.766-3.951-4.766H92.695Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M108.24-86.6v-31H122.5v4.637h-8.932v7.988h6.871v4.636h-6.871v9.105H123.1V-86.6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M126.693-86.6v-31h14.258v4.637h-8.932v7.988h6.872v4.636h-6.872v9.105h9.534V-86.6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M145.066-117.607h7.3c4.981,0,8.244,3.349,8.244,8.5s-3.263,8.5-8.244,8.5h-3.951v14h-3.35Zm3.35,14.171h3.519c3.35,0,5.327-1.8,5.327-5.668s-1.977-5.669-5.327-5.669h-3.519Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M167.379-117.607v28.17h10.049V-86.6h-13.4v-31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M190.844-117.607l6.828,31h-3.35l-1.845-9.191h-7.9L182.728-86.6h-3.349l6.826-31Zm-5.8,18.979H192l-3.434-16.661h-.086Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M205.8-117.607l7.986,22.844h.084v-22.844h3.352v31h-3.608L204-113.571h-.086V-86.6h-3.348v-31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M236.135-117.607v2.834h-6.358V-86.6h-3.349v-28.17h-6.356v-2.834Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M253.357-117.607v2.834h-10.82v10.563h7.986v2.834h-7.986v11.939h11.338V-86.6H239.187v-31Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M257.5-117.607h5.756c6.525,0,10.476,3.606,10.476,15.5s-3.951,15.5-10.476,15.5H257.5Zm3.35,28.17h1.8c4.9,0,7.731-2.063,7.731-12.669s-2.834-12.667-7.731-12.667h-1.8Z",
    fill: "#000000"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M-43.932-143.674A41.632,41.632,0,0,0-85.516-102.09,41.631,41.631,0,0,0-43.932-60.506,41.63,41.63,0,0,0-2.348-102.09,41.631,41.631,0,0,0-43.932-143.674ZM-24.6-71.193c-.208-.076-.391-.166-.391-.234a.669.669,0,0,0-.586-.728c-.323,0-1.684-.541-2.038-.541a.681.681,0,0,0-.451.179c-.128-.112-.689-.506-.689-.7a.891.891,0,0,0-.782-.971c-.428,0-1.428-.45-1.857-.45S-35.7-76.6-36.133-76.6a.7.7,0,0,0-.528.257.766.766,0,0,0-.673-.482.381.381,0,0,1-.3-.37.89.89,0,0,0-.777-.97c-.282,0-1.01-.6-1.441-.6-.048,0-1.356-1.082-1.786-1.082a4.121,4.121,0,0,1-1.036-.453c-.25-5.622-.891-9.886-1.137-12.093-.125-1.119-.208-1.728-.208-1.728-.165-1.062-.287-2.4-.378-3.93-.528-8.91-.005-24.41.314-31.122.046-1.029.09-1.861.121-2.423,0-.1.011-.185.016-.262,0-.106.008-.2.014-.266.006-.123.009-.187.009-.187a6.776,6.776,0,0,0-.822,2.8A140.473,140.473,0,0,0-46.6-111.926c-.1,1.961-.154,3.824-.186,5.561a100.157,100.157,0,0,0,.325,11.578c.335,4.616.639,9.1,1.1,14.72-.136.049-.279.1-.429.168-.67.283-1.4.692-1.485.994-.065.224-.287.47-.463.47-.339,0-1.148,1.237-1.237,1.237a3.262,3.262,0,0,0-1.712,1.491,1.671,1.671,0,0,1-1.023.7c-.43,0-1.25.971-1.68.971-.3,0-1.476.318-1.9.318a.782.782,0,0,0-.7.54,1.665,1.665,0,0,0-1.122-.387c-.756,0-1.741.722-1.937.722a.66.66,0,0,0-.389.131.661.661,0,0,0-.391-.131.6.6,0,0,0-.111.012.6.6,0,0,0-.11-.012c-.434,0-1.584,1.365-1.862,1.365a3.667,3.667,0,0,0-.938.346h-.329A36.47,36.47,0,0,1-80.4-102.09a36.508,36.508,0,0,1,36.466-36.466A36.508,36.508,0,0,1-7.465-102.09h0A36.465,36.465,0,0,1-24.6-71.193Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M-49.038-101.49a12.426,12.426,0,0,0-7.159-5.27c-.366-.116-.746-.222-1.143-.321,0,0-5.417-1.273-7.636-1.081,0,0,.035.017.108.049.3.135.938.563,2.238,1.236a54.17,54.17,0,0,1,8.46,5.359c3.019,2.387,5.864,3.787,6.841,6.943a19.906,19.906,0,0,0-.579-4.513A12.086,12.086,0,0,0-49.038-101.49Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M-38.954-120.291a34.11,34.11,0,0,1,5.639-2.85c.857-.343,1.473-.555,1.67-.623.047-.016.071-.022.071-.022a26.283,26.283,0,0,0-5.051.2c-.255.035-.5.08-.737.131a7.832,7.832,0,0,0-4.817,2.874c-1.038,1.324-1.446,4.476-1.5,5.188A11.989,11.989,0,0,1-38.954-120.291Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M-41.781-94.6c.358-.485.709-1.014,1.12-1.526.43-.493.835-1.036,1.33-1.513l.723-.743.772-.7c.366-.349.767-.657,1.163-.967.139-.11.277-.219.418-.327l.022-.017a.066.066,0,0,1,.018-.014c.185-.14.368-.281.556-.414.524-.363,1.05-.709,1.583-1.005.1-.059.206-.111.308-.167a.054.054,0,0,0,.016-.01l.046-.023c.182-.1.363-.195.543-.284l.221-.118c.44-.222.869-.407,1.278-.574a17.275,17.275,0,0,0-6.112,1.683,15.639,15.639,0,0,0-1.426.965,10.154,10.154,0,0,0-3.362,4.042,7.41,7.41,0,0,0-.349,1,7.169,7.169,0,0,0-.175.83c.048.691.113,1.3.194,1.811.077-.153.15-.306.231-.468C-42.389-93.6-42.1-94.086-41.781-94.6Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M-29.5-103.465c-.141.022-.283.046-.441.078-.142.034-.3.074-.451.113-.353.109-.725.261-1.131.429-.465.212-.965.455-1.473.745q-.379.225-.776.46c-.26.162-.516.348-.781.525-.539.343-1.04.779-1.575,1.18-.495.452-1.034.869-1.5,1.364l-.718.718q-.334.381-.664.757c-.456.488-.821,1.037-1.212,1.532-.369.512-.682,1.041-1,1.52-.271.508-.53.99-.768,1.431l-.54,1.259c-.031.063-.053.126-.079.187-.043.136-.073.226-.086.268a15.665,15.665,0,0,0,3.506-1.381,18.713,18.713,0,0,0,4.376-3.214,19.832,19.832,0,0,0,4.129-6.01,4.41,4.41,0,0,1,2.642-2.021l-.091-.006A7.269,7.269,0,0,0-29.5-103.465Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M-49.295-123.935a11,11,0,0,0-.955-.645,11.546,11.546,0,0,0-4.09-1.126c.274.111.56.234.855.384l.149.077c.12.06.241.125.362.19a.192.192,0,0,0,.031.018l.011.006.2.11c.358.2.709.431,1.06.673.125.09.248.183.372.278l.013.009.014.01c.1.072.187.146.279.221a9.99,9.99,0,0,1,.778.647l.519.466c.161.168.322.333.481.5.332.319.6.684.892,1.013.273.343.509.695.748,1.022.137.224.4.739.576,1.044l.159-1.5c-.071-.248-.164-.58-.211-.69A6.788,6.788,0,0,0-49.295-123.935Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M-47.185-117.977q-.162-.38-.362-.842l-.514-.959c-.214-.322-.422-.673-.669-1.017-.263-.331-.508-.7-.812-1.025l-.444-.506-.481-.481c-.313-.331-.674-.61-1.005-.913-.357-.268-.692-.559-1.054-.789-.178-.12-.348-.244-.522-.351s-.35-.207-.519-.308c-.341-.195-.675-.357-.986-.5-.272-.111-.521-.214-.758-.287-.1-.026-.2-.052-.3-.074s-.2-.039-.3-.052a4.724,4.724,0,0,0-.911-.046c-.037,0-.06,0-.06,0h0a2.951,2.951,0,0,1,1.767,1.355,13.26,13.26,0,0,0,2.766,4.02,12.409,12.409,0,0,0,2.926,2.151,10.242,10.242,0,0,0,2.346.923c-.01-.027-.029-.088-.058-.178C-47.149-117.894-47.166-117.934-47.185-117.977Z",
    fill: "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnetreeplantedlogo);
export default __webpack_public_path__ + "static/media/onetreeplantedlogo.24becd59cbfb977b4a307fcb70cf3707.svg";
export { ForwardRef as ReactComponent };